import { Row, Col } from "reactstrap"
import InfoCard from "../../../common/AdminCommonComponents/InfoCard/InfoCard"
import GeneralBackButton from "../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"

const ActiveCampaignsDetails = () => {

  const campaignDetail = [
    { label: "Warehouse ID", value: "#5678" },
    { label: "Partner Name", value: "LogisticsPro" },
    { label: "Location", value: "New York, USA" },
    { label: "Capacity", value: "5000 sq. ft." },
    { label: "Available Space", value: "2500 sq. ft." },
    { label: "Status", value: "Active" },
    { label: "Contact Person", value: "Jane Doe" },
    { label: "Contact Email", value: "jane.doe@logisticspro.com" },
    { label: "Contact Phone", value: "+1-234-567-8901" },
  ];

  return (
    <div className="bg-white p-3 mt-3 shadow m-3">
      <GeneralBackButton />

      <div class="fw-semibold fs-4 text-center mb-3">Active Campaign Detail</div>
      <Row className="row-cols-1 row-cols-xl-3">
        <Col>
          <InfoCard title="General Information" headerColor="#FBBD34" data={campaignDetail} />
        </Col>
      </Row>
    </div>
  )
}

export default ActiveCampaignsDetails
